// extracted by mini-css-extract-plugin
module.exports = {"container":"VPExchange_container__1VezY","from":"VPExchange_from__T6Kvs","arrow":"VPExchange_arrow__iStPq","error":"VPExchange_error__3j2Iy","to":"VPExchange_to__ftgrJ"};